import styled from 'styled-components';

import Button from '@components/Button';

export const StyledButton = styled(Button)`
  width: 100%;

  height: 56px !important;
`;
